import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import { ClienteModulo } from "../types/Clientes";
import Swal from 'sweetalert2'
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default function usePutCliente(onSuccess: () => void, isLoading: () => void) {
  return useMutation(({clienteAtual, id, data} : {clienteAtual: ClienteModulo, id : number, data : ClienteModulo}) => 
    { 
      // @ts-ignore
      Object.keys(data as any).forEach((key : string) => data[key] === undefined && delete data[key])

      Object.assign(clienteAtual, data)

    return api.put(`${URLS.CLIENTES_API}/${id}`, clienteAtual)
      .then((response: any) => {
        console.log(response)
        Swal.fire({
          title: "Cliente Editado",
          text: "O cliente foi editado com sucesso!",
          icon: "success",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#349946",
          allowOutsideClick: false
        }).then(() => {
          onSuccess();
          queryClient.invalidateQueries();
        })
      })
      .catch((err: any) => {
        err.response.status === 500 ?
          Swal.fire({
            title: `Erro de status ${err.response.status}`,
            text: `Ocorreu um erro interno ao editar o cliente. Por favor, entre em contato com um administrador do sistema.`,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          })
        :
          Swal.fire({
            title: "Erro ao editar o cliente",
            text: err.response.data.message,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          });
      }
    )
  })
}